export default defineNuxtRouteMiddleware((to) => {
    const { mode } = useMaintenance()
    if (isMaintenancePageAllowed(mode.value, stripLocalePrefix(to.path))) return
    return navigateTo(maintenancePagePath(to.path))
})
